var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSelect, FieldText, FlexBox, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { Field, SubmissionError } from 'redux-form';
import { analytics } from 'app/utils/segment';
import TemplateField from '../../../../../../shared/util/TemplateField';
import style from '../../templates.module.scss';
export class TemplatesAddModalView extends PureComponent {
    handleFormSubmit(values) {
        const { currentTemplate, reset, templates, notificationAdd, onClose } = this.props;
        const { create, update } = templates;
        const reg = /[<>="']/g;
        if (reg.test(values.name)) {
            throw new SubmissionError({ name: 'Name: forbidden characters: <>="' });
        }
        if (!currentTemplate) {
            const payload = {
                name: values.name,
                subject: values.subject,
                content: values.content,
                type: values.type,
            };
            create(payload)
                .then((r) => {
                analytics.settingsTemplatesModalFormSubmitted({
                    mode: 'add',
                    templateType: values.type,
                    templateName: values.name,
                });
                notificationAdd({
                    title: `Template created`,
                    text: `Template "${values.name}" created`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                }),
                    reset();
                onClose();
            })
                .catch((e) => {
                notificationAdd({
                    title: 'An error occurred',
                    text: `An error occurred when trying to create the "${values.name}" template`,
                    icon: 'i-exclamation',
                    className: 'danger',
                });
                throw new SubmissionError({ name: 'Template already exist' });
            });
        }
        else {
            const payload = {
                updates: {
                    content: values.content,
                    subject: values.subject,
                    name: currentTemplate.name,
                },
                deletes: [],
            };
            if (currentTemplate.name.trim() !== values.name.trim()) {
                payload.updates.name = values.name;
            }
            if (!values.subject) {
                payload.deletes.push('subject');
                delete payload.updates.subject;
            }
            update(currentTemplate.id, payload)
                .then((r) => {
                var _a;
                analytics.settingsTemplatesModalFormSubmitted({
                    mode: 'edit',
                    templateType: (_a = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.type) !== null && _a !== void 0 ? _a : values.type,
                    templateName: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.name,
                });
                notificationAdd({
                    title: `Template updated`,
                    text: `Template "${values.name}" updated`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                }),
                    reset();
                onClose();
            })
                .catch((e) => {
                notificationAdd({
                    title: 'An error occurred',
                    text: `An error occurred when trying to update the "${values.name}" template`,
                    icon: 'i-exclamation',
                    className: 'danger',
                });
            });
        }
    }
    render() {
        const { handleSubmit, currentTemplate, isAddModalOpen, onClose } = this.props;
        const templateName = currentTemplate && currentTemplate.name ? currentTemplate.name : '';
        const modalTitle = currentTemplate
            ? `Edit template "${templateName}"`
            : 'Add new template';
        const templateTypes = [
            { id: 'quick_response', name: 'Quick response' },
            { id: 'email_auto_reply', name: 'Auto reply' },
        ];
        const helptext = `You can use these replacing variables eg. *{{agent_fullname}}* with the actual agent name.:

      {{organization_name}}
      {{requester_firstname}}
      {{requester_fullname}}
      {{requester_email}}
      {{agent_firstname}}
      {{agent_fullname}}
      {{conversation_subject}}
      {{csid}}

      _note_: csid is the conversation ID.`;
        return (_jsx(Modal, Object.assign({ isOpen: isAddModalOpen, onClose: () => onClose(true) }, { children: _jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(ModalHead, { title: modalTitle, onClose: () => onClose(true) }), _jsx(ModalBody, Object.assign({ className: style.templatesAddModalBody }, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column" }, { children: [_jsx(Field, { label: "Name", name: "name", component: FieldText, type: "text", required: true, placeholder: "Name...", helpIconText: "Template name should only be in lowercase and not contain any whitespace or special characters", helpIconTitle: "Template name" }), _jsx(Field, { label: "Subject", name: "subject", component: FieldText, type: "text", required: true, placeholder: "Subject...", helpIconTitle: "Subject", helpIconText: `This field is used to fill out the subject line in emails when composing emails and for auto-replies. The subject line is not used if the template is used in chat or you are replying to an email. You can use these variables: ${helptext}`, className: style.templatesFormField }), !currentTemplate && (_jsx(Field, { label: "Template type", required: true, name: "type", component: FieldSelect, placeholder: "Please select a template type", items: templateTypes, className: style.templatesFormField })), _jsx("div", Object.assign({ className: style.templatesFormField }, { children: _jsx(Field, { displayName: "Template Content", name: "content", component: TemplateField, required: true, placeholder: "content...", showHelpIcon: true, helpIconTrigger: ['click'], helpIconTitle: "Template Content", helpIconText: `The content is written in HTML and supports [Liquid](https://shopify.github.io/liquid/) too. \n\n${helptext}` }) }))] })) })), _jsx(ModalFoot, { cancelOnClick: () => onClose(true), confirmOnClick: handleSubmit(this.handleFormSubmit), cancelName: "Cancel", confirmName: "Save", confirmProps: { type: 'submit' } })] })) })));
    }
}
__decorate([
    boundMethod
], TemplatesAddModalView.prototype, "handleFormSubmit", null);
